import { IInvoiceItem } from "../interfaces/invoice/IInvoice";

export const calculateTotalPrice = (
  invoiceItems: IInvoiceItem[],
  taxes: number,
  discount: number,
): number => {
  const itemsSum = calculateSubtotalPrice(invoiceItems);
  const discounted = itemsSum * (1 - discount / 100);
  const taxed = discounted * (1 + taxes / 100);

  return parseFloat(taxed.toFixed(2)) || 0;
};

export const calculateSubtotalPrice = (invoiceItems: IInvoiceItem[]) => {
  return (
    invoiceItems?.reduce(
      (prev, curr) => prev + curr.price * curr.quantity,
      0,
    ) || 0
  );
};
